import React, { useRef } from "react";
import Header from "../Header";
import LeftMenu from "../LeftMenu";
import DashboardSelector from "../DashboardSelector";
import DashboardFilter from "./DashboardFilter";
import { UTILISATION_SHOW_DESK } from "../../constants/general-constants";
import { NON_HERO_BACKGROUND } from "../../constants/styles";

export default function FilterableDashboardTemplate({ title, childDashboards, children, filter, setFilter }) {

    const refFacility = useRef(null);
    const blankFunction = () => {};

    // -----------------------------
    // OUTER WRAPPER (FULL LOCK)
    // -----------------------------
    const thisContainer = {
        display: "flex",
        position: "fixed",
        flexDirection: "column",
        width: "100%",
        top: "0px",
        bottom: "0px",
        left: "0px",
        overflow: "hidden"   // 🔥 prevents page scroll
    };

    // -----------------------------
    // MAIN AREA (UNDER HEADER + MENU)
    // -----------------------------
    const mainContainer = {
        display: "flex",
        position: "fixed",
        top: "0px",     // header height
        left: "60px",    // menu width
        right: "0px",
        bottom: "0px",
        overflow: "hidden",   // 🔥 no scrolling here
		background:
		      "linear-gradient(135deg, " +
		      "rgba(255,255,255,0.74) 0%, " +
		      "rgba(235,242,248,0.78) 100%)"
    };

    // -----------------------------
    // CONTENT PANEL (THIS SCROLLS)
    // -----------------------------
    const contentContainer = {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        padding: "20px",
        boxSizing: "border-box",
        gap: "20px",
        overflowY: "auto",   // 🔥 ONLY SCROLL HERE
        overflowX: "hidden",
        minHeight: 0,         // 🔥 critical flex fix
		marginTop:'60px'
    };

    return (
        <div style={thisContainer}>

            <Header transitionHide={true}/>
            <LeftMenu />

            <DashboardSelector
                title={title}
                childDashboards={childDashboards}
            />

            <div style={mainContainer}>

                {/* ---------------- FILTER (FIXED LEFT) ---------------- */}
                <DashboardFilter
                   filter={filter}
				   setFilter={setFilter}
                />

                {/* ---------------- CONTENT (SCROLLABLE) ---------------- */}
                <div style={contentContainer}>
                    {children}
                </div>

            </div>

        </div>
    );
}